import React from "react";
import ReactDOM from "react-dom";
import { createRoot } from 'react-dom/client'
import { createBrowserHistory } from "history";
import { Router, Route, Switch, Redirect, BrowserRouter } from "react-router-dom";
import { inject, observer, Provider } from "mobx-react";

import { RecoilRoot } from "recoil";

import { sessionService, sessionReducer } from 'redux-react-session';



import configureStore from "./store";

import routes from "./routes";

import i18n from "./i18n";

import './index.css';

import App from './App';



const hist = createBrowserHistory();



export var store = configureStore();

// Init the session service
sessionService.initSessionService(store);






createRoot(document.getElementById('root')).render(
    <Provider store={store} history={hist}>
     <RecoilRoot>
       <App store={store} history={hist}/>
     </RecoilRoot>
    </Provider>
)
